// extracted by mini-css-extract-plugin
export default {"container":"EventNavbar_container__BmAjr","title":"EventNavbar_title__HsCaq","tabs":"EventNavbar_tabs__Co88e","tab":"EventNavbar_tab__u7ySs","active":"EventNavbar_active__vGg7h"};